import { String } from "@siteimprove/alfa-string";
import { Trampoline } from "@siteimprove/alfa-trampoline";
import { Iterable } from "@siteimprove/alfa-iterable";
import { Node } from "../node.js";
import { Element } from "./element.js";
/**
 * @public
 */
export class Fragment extends Node {
    static of(children, externalId, internalId, extraData) {
        return new Fragment(Array.from(children), externalId, internalId, extraData);
    }
    static empty() {
        return new Fragment([]);
    }
    constructor(children, externalId, internalId, extraData) {
        super(children, "fragment", externalId, internalId, extraData);
    }
    /**
     * @internal
     **/
    _internalPath() {
        return "/";
    }
    toString() {
        const children = this._children
            .map((child) => String.indent(child.toString()))
            .join("\n");
        return `#document-fragment${children === "" ? "" : `\n${children}`}`;
    }
    /**
     * @internal
     */
    _attachParent() {
        return false;
    }
}
/**
 * @public
 */
(function (Fragment) {
    function isFragment(value) {
        return value instanceof Fragment;
    }
    Fragment.isFragment = isFragment;
    /**
     * @internal
     */
    function fromFragment(json, device) {
        return Trampoline.traverse(json.children ?? [], (child) => Node.fromNode(child, device)).map((children) => Fragment.of(children));
    }
    Fragment.fromFragment = fromFragment;
    /**
     * @internal
     */
    function cloneFragment(options, device) {
        return (fragment) => Trampoline.traverse(fragment.children(), (child) => {
            if (Element.isElement(child) && options.predicate(child)) {
                return Trampoline.done(Array.from(options.newElements));
            }
            return Node.cloneNode(child, options, device).map((node) => [node]);
        }).map((children) => {
            return Fragment.of(Iterable.flatten(children), fragment.externalId);
        });
    }
    Fragment.cloneFragment = cloneFragment;
})(Fragment || (Fragment = {}));
//# sourceMappingURL=fragment.js.map